<template>
  <v-list-group no-action :color="$store.getters['settings/dark'] ? 'white' : 'black'">
    <template v-slot:activator>
      <v-list-item-icon class="mr-4">
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Отчёты</v-list-item-title>
      </v-list-item-content>
    </template>
    <Income />
    <Outcome />
    <Rests />
    <MX20 v-if="$store.state.auth.user.role !== 'Кладовщик'" />
    <template v-if="$store.state.auth.user.role !== 'Клиент'">
      <ProceededCarsAndRequests />
      <Billing v-if="$store.state.auth.user.role !== 'Кладовщик'" />
      <Verification v-if="['Администратор', 'Управляющий'].includes($store.state.auth.user.role)" />
      <IncidentRecordsMenuItem v-if="[10, 20, 23, 45].includes(parseInt($store.state.auth.user?.userID || 0))" />
    </template>
  </v-list-group>
</template>

<script>
import Income from "@/reports/Income.vue"
import Outcome from "@/reports/Outcome.vue"
import Rests from "@/reports/Rests.vue"
import MX20 from "@/reports/MX20.vue"
import ProceededCarsAndRequests from "@/reports/ProceededCarsAndRequests.vue"
import Billing from "@/reports/Billing.vue"
import Verification from "./Verification.vue"
import IncidentRecordsMenuItem from "@/components/IncidentRecordsMenuItem.vue"
import ReserveRecordsMenuItem from "@/components/ReserveRecordsMenuItem.vue"

export default {
  components: {
    Income,
    Outcome,
    Rests,
    MX20,
    ProceededCarsAndRequests,
    Billing,
    Verification,
    IncidentRecordsMenuItem,
    ReserveRecordsMenuItem
  }
}
</script>

<style>
/* .v-list-item {
  min-height: 32px;
} */
</style>
